import { fontSizeVars, smallTextPreset } from '@tundr/ds-foundations';
import { semanticTokenVars } from '@tundr/ds-tokens';
import { style, styleVariants } from '@vanilla-extract/css';

export const appVersionClass = style({
  width: '100%',
  overflow: 'hidden',
  textAlign: 'left',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  fontSize: fontSizeVars.body.body3,
});

export const toneVariants = styleVariants({
  default: { color: semanticTokenVars.content.placeholder.default },
  onBrand: { color: semanticTokenVars.content.onBrand.default },
  onBrandMuted: {
    ...smallTextPreset,
    color: semanticTokenVars.accent.green.default.pale,
  },
});
